import { render, staticRenderFns } from "./TheHeading.vue?vue&type=template&id=1ffb3990&scoped=true&"
import script from "./TheHeading.vue?vue&type=script&lang=js&"
export * from "./TheHeading.vue?vue&type=script&lang=js&"
import style0 from "./TheHeading.vue?vue&type=style&index=0&id=1ffb3990&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb3990",
  null
  
)

export default component.exports